<script>
// const uid = 0
// const token = ''
const urlOld = '/tp/index.php/'
const url0 = '/tp8/index.php/'
// function save (id, key) {
//   this.uid = id
//   this.token = key
// }
export default {
  urlOld,
  url0,
  // uid,
  // token
  // save
}
</script>



// WEBPACK FOOTER //
// src/components/Global.vue